import Container from './Container.vue'

export default {
	install: Vue => {
		Vue.component('ace-container', Container)
	}
}



// WEBPACK FOOTER //
// ./src/components/container/index.js